const rules = {
	user: {
		static: [],
	},

	admin: {
		static: [
			"admin-page:view",
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"ticket-options:transferQueue",
			"ticketlist-item:viewTicket",
			"contacts-page:deleteContact",
			"contacts-page:importContact",
			"contacts-page:exportContact",
			"connections-page:actionButtons",
			"connections-page:addConnection",
			"connections-page:editOrDeleteConnection"
		],
	},

	adminSuper: {
		static: [
			"admin-page:view",
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"ticket-options:transferQueue",
			"ticketlist-item:viewTicket",
			"contacts-page:deleteContact",
			"contacts-page:importContact",
			"contacts-page:exportContact",
			"connections-page:actionButtons",
			"connections-page:addConnection",
			"connections-page:editOrDeleteConnection"
		],
	},
};

export default rules;
